import { createRouter, createWebHistory } from 'vue-router'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: () => import('../layouts/AuthLayout.vue'),
      children: [
        {
          path: '/',
          name: 'Login',
          component: () => import('../components/Login.vue'),
        },
        {
          path: '/registration',
          name: 'Registration',
          component: () => import('../components/Registration.vue'),
        },
        {
          path: '/user',
          name: 'User',
          component: () => import('../components/User.vue'),
        },
      ],
    },
  ],
})
